export class AreaTimeModel {
  // Definisco un construttore con valori di default vuoti in sostituzione del costruttore senza parametri
  public typology: [];
  public belonging_groups: [];
  public cdc: string;
  public notes: string;
}
